module.exports = __webpack_public_path__ + "img/select-another-trigger.c6bdbbb5.png";